












import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import BaseAvatar from "@/components/BaseAvatar";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";

export default defineComponent({
  name: "CreatorsListItem",
  components: { ScreenNamePrinter, BaseAvatar },
  props: {
    creator: { type: Object as () => UserPublicData, required: true },
  },
  setup(props, { emit }) {
    const getUserUrl = computed(() => getProfileUrl(props.creator));
    const showStoryInfo = computed(() => config.featureStories);
    const hasStories = computed(() => config.featureStories && props.creator.hasStories);
    const handleAvatarClick = () => {
      if (!hasStories.value) return;
      emit("creatorClick", props.creator);
    };
    return { getUserUrl, showStoryInfo, hasStories, handleAvatarClick };
  },
});
